import React from "react";

function UserCenterButton({ Tooltip, onClick, trackid, Latitude, Longitude }) {
    const showButton = Tooltip !== "true";

    if (!showButton) return null;

    return (
        <button
            className="user-center-button"
            onClick={(event) => {
                event.stopPropagation();
                onClick(trackid, Latitude, Longitude);
            }}
            aria-label="Centreer kaart op mijn locatie"
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="user-center-icon"
            >
                {/* Outer circle (crosshair) */}
                <circle
                    cx="12"
                    cy="12"
                    r="8"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                />
                {/* Inner dot (current location) */}
                <circle
                    cx="12"
                    cy="12"
                    r="3"
                    fill="var(--company-color)"
                />
                {/* Crosshair lines */}
                <line x1="12" y1="2" x2="12" y2="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <line x1="12" y1="19" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <line x1="2" y1="12" x2="5" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <line x1="19" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </button>
    );
}

export default UserCenterButton;
